import { h, Component, Fragment } from 'preact';
import { riperStorage, i18n } from '@/base/helpers';
import Redeem from '@/liana/views/modals/Redeem';
import { getDataButton } from '../utils';

export default class CheckoutButton extends Component {
  constructor(props) {
    // props: { account, cart, coupon, display, onAbout }
    super(props);
    this.state = {
      account: props.account,
      coupon: props.coupon,
      cart: props.cart,
      status: '',
      message: '',
    };
  }

  componentDidMount() {
    this.setState((prevState) => ({
      ...prevState,
      account: riperStorage.account,
      cart: riperStorage.cart,
      coupon: riperStorage.coupon,
    }));

    // (The "domElem" elem is assigned in the render function.)
    this.domElem.addEventListener('event:liana:redemption', this.handleRedemption);
  }

  componentWillUnmount() {
    this.domElem.removeEventListener('event:liana:redemption', this.handleRedemption);
  }

  handleRedemption = (event) => {
    this.setState((prevState) => ({ ...prevState, ...event.detail }));
  };

  render() {
    const { display, onAbout, CheckoutButtonComponent } = this.props;
    const { status, message, account, coupon, cart } = this.state;
    const cartValue = cart ? cart.total_price : null;
    const { textButton, clickButton, classButton, textInfo, isDisabled } = getDataButton({
      display,
      account,
      coupon,
      cartValue,
      status,
      message,
      onAbout,
    });

    return (
      <Fragment>
        <div ref={(elem) => (this.domElem = elem)}>
          <CheckoutButtonComponent
            textButton={textButton}
            clickButton={clickButton}
            classButton={classButton}
            textInfo={textInfo}
            isDisabled={isDisabled}
          />
        </div>
        <Redeem
          title={i18n.t('redemption', 'redemption_failed')}
          isOpen={status === 'error'}
          onClose={() => this.setState((prevState) => ({ ...prevState, status: '' }))}
          status={status}
          message={message}
          coupon={coupon}
        />
      </Fragment>
    );
  }
}
